import { useAccountPlantUsageSync } from "@Broker/@Composables/account-plan/useAccountPlanUsageSync";
import { useScrollToBottom } from "@Shared/@Composables/generic/useScrollToBottom";
import { defineComponent, onMounted, ref, toRefs } from "@vue/composition-api";
import * as AutomationActions from "../../../store/automation-actions";
import { useAutomationStoreActions, useAutomationStoreMutations } from "../../../store/automation-helpers";
import * as AutomationMutations from "../../../store/automation-mutations";
import DocumentAutomationRequestTitle from "./document-automation-request-title.vue";
import DocumentManage from "./documents-manage.vue";
export default defineComponent({
  name: "DocumentAutomationRequestCard",
  components: {
    DocumentManage,
    DocumentAutomationRequestTitle
  },
  props: {
    automation: {
      type: Object,
      required: true
    }
  },
  setup(props) {
    const {
      scrollContainer,
      scrollToBottom
    } = useScrollToBottom();
    const {
      syncAccountPlanUsage
    } = useAccountPlantUsageSync();
    const toggleLoading = ref(false);
    const saving = ref(false);
    const automation = toRefs(props.automation);
    const {
      UPDATE_DOCUMENT_REQUEST_AUTOMATION_RULE
    } = useAutomationStoreActions([AutomationActions.UPDATE_DOCUMENT_REQUEST_AUTOMATION_RULE]);
    const {
      REMOVE_DOCUMENT_CLASSIFICATION,
      ADD_DOCUMENT_CLASSIFICATION,
      EDIT_DOCUMENT_CLASSIFICATION,
      TOGGLE_DOCUMENT_REQUEST_EDIT_MODE
    } = useAutomationStoreMutations([AutomationMutations.REMOVE_DOCUMENT_CLASSIFICATION, AutomationMutations.ADD_DOCUMENT_CLASSIFICATION, AutomationMutations.EDIT_DOCUMENT_CLASSIFICATION, AutomationMutations.TOGGLE_DOCUMENT_REQUEST_EDIT_MODE]);
    const showDocumentsCard = ref(false);
    const handleCollapseClick = () => {
      showDocumentsCard.value = !showDocumentsCard.value;
    };
    const handleToggleActive = async active => {
      toggleLoading.value = true;
      await syncAccountPlanUsage(() => UPDATE_DOCUMENT_REQUEST_AUTOMATION_RULE({
        documentRequestRuleId: automation.id.value,
        active
      }));
      toggleLoading.value = false;
    };
    const triggerSaveTimeout = ref(null);
    const triggerDelayedSave = (relatedAction = "") => {
      if (triggerSaveTimeout.value) window.clearTimeout(triggerSaveTimeout.value);
      triggerSaveTimeout.value = window.setTimeout(async () => {
        saving.value = true;
        await UPDATE_DOCUMENT_REQUEST_AUTOMATION_RULE({
          documentRequestRuleId: automation.id.value,
          documentRequestRule: automation.documentRequestRule.value
        });
        if (relatedAction === "add-document") {
          scrollToBottom(".document-rows");
        }
        saving.value = false;
      }, 500);
    };
    const handleDeleteDocument = async documentIndex => {
      REMOVE_DOCUMENT_CLASSIFICATION({
        documentRequestRuleId: automation.id.value,
        documentIndex
      });
      triggerDelayedSave();
    };
    const handleAddDocument = async ({
      classification,
      description
    }) => {
      ADD_DOCUMENT_CLASSIFICATION({
        documentRequestRuleId: automation.id.value,
        documentClassification: {
          classification,
          description
        }
      });
      triggerDelayedSave("add-document");
    };
    const handleEditDocument = async (documentIndex, {
      description
    }) => {
      EDIT_DOCUMENT_CLASSIFICATION({
        documentRequestRuleId: automation.id.value,
        documentClassification: {
          description
        },
        documentIndex
      });
      triggerDelayedSave();
    };
    const handleToggleEdit = () => {
      TOGGLE_DOCUMENT_REQUEST_EDIT_MODE({
        documentRequestRuleId: automation.id.value
      });
    };
    onMounted(() => {
      TOGGLE_DOCUMENT_REQUEST_EDIT_MODE({
        documentRequestRuleId: automation.id.value,
        editing: false
      });
    });
    return {
      scrollContainer,
      handleDeleteDocument,
      handleAddDocument,
      handleEditDocument,
      toggleLoading,
      handleToggleActive,
      handleCollapseClick,
      handleToggleEdit
    };
  }
});